import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  deleteApiV2CustomersCustomerIdBundleRatingId,
  type Params,
} from '@hungryroot/rest/api/v2/customers/[id]/bundle_ratings/[bundle_id]/delete';

type UseDeleteCustomerBundleRatingProps<Context> = Omit<
  UseMutationOptions<void, Error, Params, Context>,
  'mutationFn'
>;

export function useDeleteCustomerBundleRating<Context>(
  props?: UseDeleteCustomerBundleRatingProps<Context>
) {
  return useMutation({
    mutationFn: async (params: Params) => {
      const res = await deleteApiV2CustomersCustomerIdBundleRatingId(params);

      if (res.status !== StatusCode.SuccessNoContent) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }

      return res.data;
    },
    ...props,
  });
}
